import { Typography, Box, CircularProgress } from '@mui/material'
import React, { useEffect, useState, useCallback } from 'react'
import CommonApi from '@/pages/api'
import TruncatedText from '@/src/components/announcement-content/TruncatedText'
import { formatDate } from '@/src/types/helper'

interface QuestionSectionProps {
  sectionId: number
  isDraft?: boolean
}
const QuestionSection = ({ sectionId, isDraft = false }: QuestionSectionProps) => {
  const [loading, setLoading] = useState(false)
  const [questionSectionData, setQuestionSectionData] = useState<any>()

  const fetchQuestionSectionData = useCallback(async () => {
    setLoading(true)
    try {
      const response = await CommonApi({
        method: 'get',
        path: `show-pinned-content/${sectionId}${isDraft ? '?status=draft' : ''}`
      })
      if (response.status) {
        setQuestionSectionData(response.data)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }, [sectionId, isDraft])

  useEffect(() => {
    fetchQuestionSectionData()
  }, [fetchQuestionSectionData])

  return (
    <Box className={`w-full flex justify-center `}>
      {loading ? (
        <Box className="w-full flex justify-center items-center h-[300px]">
          <CircularProgress size={25} />
        </Box>
      ) : (
        <Box className="w-full">
          {questionSectionData?.pinned_questions?.length > 0 && (
            <Box className="grid gap-6">
              <Box className="flex justify-between">
                <Box>
                  <Typography variant="h5">Investor questions</Typography>
                </Box>
              </Box>
              <Box className="flex flex-col md:flex-row gap-4">
                {questionSectionData?.pinned_questions?.map((val: any, index: number) => (
                  <Box className="rounded-[20px] bg-[#07004D14] px-8 py-6 w-full" key={index}>
                    <Box>
                      <Typography variant="caption">
                        {formatDate(val.answer_date, 'long')}
                      </Typography>
                      <Typography variant="subtitle1" sx={{ marginTop: '8px' }}>
                        {val.question}
                      </Typography>
                    </Box>
                    <Box>
                      <Box sx={{ marginTop: '12px', fontWeight: 'bold' }}>
                        {val?.answer && (
                          <TruncatedText
                            question={{ summary: val.answer, toggle: true }}
                            maxLength={200}
                          />
                        )}
                      </Box>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          )}
        </Box>
      )}
    </Box>
  )
}

export default QuestionSection
